/**
 * ZIP Bulk Exporter — uses JSZip
 */
export async function downloadBulkZIP(candidates, settings, mode, templateUrl = '/template.png') {
  const JSZip = (await import('jszip')).default;
  const { generateCertificateWithTemplate } = await import('./pdfGenerator.js');

  const zip = new JSZip();
  const folderName = mode === 'internship' ? 'Offer_Letters' : 'Certificates';
  const folder = zip.folder(folderName);

  for (const candidate of candidates) {
    if (candidate.docStatus === 'generated') {
      try {
        const doc = await generateCertificateWithTemplate(candidate, templateUrl || '/template.png', settings, mode);
        const blob = doc.output('blob');
        const cleanName = (candidate.name || 'Candidate').replace(/[^a-zA-Z0-9_-]/g, '_');
        const cleanId = (candidate.generatedId || candidate.id || 'DOC').replace(/[^a-zA-Z0-9_-]/g, '_');
        const fileName = `${cleanName}_${cleanId}.pdf`;
        folder.file(fileName, blob);
      } catch (e) {
        console.error(`Failed to generate PDF for ${candidate.name}`, e);
      }
    }
  }

  const content = await zip.generateAsync({ type: 'blob' });
  const url = URL.createObjectURL(content);
  const a = document.createElement('a');
  a.style.display = 'none';
  a.href = url;
  const dateStr = new Date().toISOString().slice(0, 10);
  a.setAttribute('download', `InnovationHacks_${folderName}_${dateStr}.zip`);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);

  // Delay revoking URL so browser has time to finish saving the file with extension
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}

export const exportToZip = downloadBulkZIP;
